import AudioPlayer from './AudioPlayer.container';

export default AudioPlayer;
